import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTokenData } from 'store/state';
import { TokenDataPermissions } from 'store/state';
import { navbarItems } from 'utils/navbar/navbarItems';
import { useStoreState } from 'providers/StoreStateContext';

export const usePermissionGuard = (
  permissionName: keyof TokenDataPermissions,
  redirectPath: string = '/',
  checkChildren: boolean = false,
  mainNavbarPath?: string // Ścieżka głównej zakładki (np. 'music-product-digital')
) => {
  const tokenData = useTokenData();
  const navigate = useNavigate();
  const { applicationSettings } = useStoreState();

  useEffect(() => {
    console.log('usePermissionGuard:', {
      permissionName,
      checkChildren,
      mainNavbarPath,
      tokenData: !!tokenData,
      hasPermission: !!tokenData?.[permissionName]
    });

    if (!tokenData) {
      return;
    }

    if (!tokenData[permissionName]) {
       
      if (checkChildren && mainNavbarPath) {
        
        const allNavbarItems = navbarItems(false, applicationSettings?.extensionContract);
        
        const mainItem = allNavbarItems.find(item => 
          item.path === mainNavbarPath
        );
        
        if (mainItem?.children) {
          
          const firstAvailableChild = mainItem.children.find(child => 
            !child.permissionNames || 
            child.permissionNames.some(name => tokenData[name as keyof typeof tokenData])
          );
          
          if (firstAvailableChild) {
            navigate(`/${firstAvailableChild.path}`);
            return;
          }
        }
      }
      
      navigate(redirectPath);
    } else {
    }
  }, [tokenData, permissionName, navigate, redirectPath, checkChildren, mainNavbarPath, applicationSettings?.extensionContract]);

  return !!tokenData?.[permissionName];
}; 